import { CpsGridView } from '@cs-cms/types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { viewsKeys } from '../../queryKeys/view';

export function useGetViews(indexId?: number): UseQueryResult<CpsGridView[], unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getIndexViews = () => {
    if (servicesCtx?.viewsService && indexId != null) {
      return servicesCtx.viewsService.getViews(indexId);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: viewsKeys.indexViews(indexId),
    queryFn: getIndexViews,
    retry: 0,
    enabled: indexId != null,
    staleTime: 1800000,
    gcTime: 1800000
  });
}
